export function mapper(data: any) {
  return data.map((row: any) => ({
    รหัสและชื่อบัญชี: row.name,
    ...row.budgets,
    รวม: row.total,
  }));
}
